import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import { BreadCrumbs } from "../../../../shared/breadCrumbs/BreadCrumbs";
import { TopBar } from "../../../../shared/topBar/TopBar";
import { UrlPath } from "../../../../../config/routeConfig";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import { AllocationTab } from "./AllocationTab";
import { ProformasTreeGrid } from "./ProformasTreeGrid";
import { AllocationDetails } from "./AllocationDetails";
import {  getProformaDateAction,
  getProformaRebalanceAction,
  getProformaBackfillAction,
} from "../../../../actions/proformaAction";
export const CreateNewProformas = () => {
  const dispatch = useDispatch();
  const locationData = useLocation();
  const [profromaID,setProfromaID]=useState();
  const [loading, setLoading] = useState(true);
  const [allocationParams, setAllocationParams]=useState({
    "InitialValue": null,
    "StartDate": null,
    "EndDate": null,
    "AllocationMode": null,
    "RebalanceMethod": null,
    "RebalanceStart": null,
    "Backfill": null,
    "AutomatedReturns": null,
    "Fees": null,
  })
  useEffect(()=>{
    dispatch(getProformaDateAction("date"));
    dispatch(getProformaRebalanceAction("rbm"));
    dispatch(getProformaBackfillAction("bf"));
  },[]);
  let Level = [
      {

      BreadCrumb: "Proforma Construction > ",
      Routes: `${UrlPath.ProformaConstruction}`,
    },
  ];

  Level = loading
    ? Level
    : [
        ...Level,
        {
          BreadCrumb: `Analysis > `,
          Routes: `${UrlPath.ProformaConstruction}`,
        },
        {
          BreadCrumb: `Proforma Construction >`,
          Routes: `${UrlPath.ProformaConstruction}`,
        },
        {
          BreadCrumb: `Create New >`,
          Routes: `${UrlPath.NewProformaConstruction}`,
        },
      ];
   
  const previouslyActiveTab =
    locationData.state === null ? "Allocation" : locationData.state.ActiveTab;
 
  return (
    <>
      <>
        <div id="CreateNewProfomadiv">
          <TopBar label={"Proforma Construction"} />
          <div id="content" class="asset-detail-screen">
            <BreadCrumbs Levels={Level} />
            <div className="p-3">
              <div className="col-lg-12 mb-4">
                <Tabs
                  defaultActiveKey={previouslyActiveTab}
                  id="uncontrolled-tab-example"
                  className="ms-3"
                >
                  <Tab eventKey="Allocation" title="Allocation">
                    <div className="p-3 bg-white life-science rounded mb-4">
                      <AllocationTab OptionDate={"New"} ActiveButton={locationData.state.ActiveButton} allocationParams={allocationParams} setAllocationParams={setAllocationParams} ProfromaID={profromaID}/>
                    </div>
                    <div>
                    <ProformasTreeGrid ActiveButton={locationData.state.ActiveButton} allocationParams={allocationParams} setAllocationParams={setAllocationParams} setProfromaID={setProfromaID}/>
                    </div>
                  </Tab>

                  <Tab eventKey="AllocationDetails" title="Allocation Details">
                    <div className="p-3 bg-white life-science rounded">
                      <AllocationDetails ProfromaID={profromaID}/>
                    </div>
                  </Tab>
                </Tabs>
              </div>

            </div>
          </div>
        </div>
      </>
    </>
  );
};
